<template>
  <div class="box tqm">
    <div class="box-head bg-color1 felx-between">
      <div class="box-head-title color1 flex-algin">诚信评价查询管理</div>
      <div class="head-search ">
        <el-input placeholder="请输入姓名" prefix-icon="el-icon-search" v-model="name"></el-input>
      </div>
    </div>
    <div class="box-table">
      <el-tabs v-model="activeName" type="card" style="height:100%;">
        <el-tab-pane label="合作单位诚信评价" name="first">
            <el-table
              :data="tableList2"
              style="width: 100%;border:0;;"
              :header-cell-class-name="tableHeadCellName"
              :header-row-class-name="tableHeadRowName"
              :row-class-name="tableRowClassName"
            >
              <el-table-column prop="projectName" label="来源项目" align="center"></el-table-column>
              <el-table-column prop="personName" label="姓名" align="center"></el-table-column>
              <el-table-column prop="badRecordType" label="诚信记录" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.badRecordType=='0'">不服从项目管理</span>
                  <span v-else-if="scope.row.badRecordType=='1'">违章操作</span>
                  <span v-else-if="scope.row.badRecordType=='2'">恶意讨薪</span>
                  <span v-else-if="scope.row.badRecordType=='3'">恶意欠薪</span>
                  <span v-else>其他</span>
                </template>
              </el-table-column>
              <el-table-column prop="desc" label="事项描述" align="center"></el-table-column>
            </el-table>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 20, 30, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
              style="padding-top:10px;"
            ></el-pagination>
        </el-tab-pane>
        <el-tab-pane label="班组诚信评价" name="second">
            <el-table
              :data="tableList1"
              style="width: 100%;border:0;height:100%;"
              :header-cell-class-name="tableHeadCellName"
              :header-row-class-name="tableHeadRowName"
              :row-class-name="tableRowClassName"
            >
              <el-table-column prop="projectName" label="来源项目" align="center"></el-table-column>
              <el-table-column prop="personName" label="班组名称" align="center"></el-table-column>
              <el-table-column prop="badRecordType" label="诚信记录" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.badRecordType=='0'">不服从项目管理</span>
                  <span v-else-if="scope.row.badRecordType=='1'">违章操作</span>
                  <span v-else-if="scope.row.badRecordType=='2'">恶意讨薪</span>
                  <span v-else-if="scope.row.badRecordType=='3'">恶意欠薪</span>
                  <span v-else>其他</span>
                </template>
              </el-table-column>
              <el-table-column prop="desc" label="事项描述" align="center"></el-table-column>
            </el-table>
            <el-pagination
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page="currentPage1"
              :page-sizes="[5, 10, 20, 30, 50]"
              :page-size="pageSize1"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems1"
              style="padding-top:10px;"
            ></el-pagination>
        </el-tab-pane>
        <el-tab-pane label="工人诚信评价" name="third">
            <el-table
              :data="tableList"
              style="width: 100%;border:0;height:100%;"
              :header-cell-class-name="tableHeadCellName"
              :header-row-class-name="tableHeadRowName"
              :row-class-name="tableRowClassName"
            >
              <el-table-column prop="projectName" label="来源项目" align="center"></el-table-column>
              <el-table-column prop="personName" label="单位名称" align="center"></el-table-column>
              <el-table-column prop="badRecordType" label="诚信记录" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.badRecordType=='0'">不服从项目管理</span>
                  <span v-else-if="scope.row.badRecordType=='1'">违章操作</span>
                  <span v-else-if="scope.row.badRecordType=='2'">恶意讨薪</span>
                  <span v-else-if="scope.row.badRecordType=='3'">恶意欠薪</span>
                  <span v-else>其他</span>
                </template>
              </el-table-column>
              <el-table-column prop="desc" label="事项描述" align="center"></el-table-column>
              <!-- <el-table-column label="查看" align="center">
                <template slot-scope="scope" v-if="scope.row.id">
                  <el-button size="mini" type="primary" class="bg-color5" @click="toHistory(scope.row)">历史</el-button>
                </template>
              </el-table-column> -->
            </el-table>
            <el-pagination
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page="currentPage1"
              :page-sizes="[5, 10, 20, 30, 50]"
              :page-size="pageSize1"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems1"
              style="padding-top:10px;"
            ></el-pagination>
        </el-tab-pane>
      </el-tabs>
      
    </div>
    <!-- <div style="width:100%;">
      
    </div> -->
  </div>
</template>
<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
export default {
  data() {
    return {
      tableList: [],
      tableHeadCellName: 'table-head-cell',
      tableHeadRowName: 'table-head-row',
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      name: '',
      joinType:'',
      activeName:'first',
      tableList1:[ //班组不良记录列表
      ],
      currentPage1: 1,
      pageSize1: 10,
      totalItems1: 0,
      tableList2:[  //合作单位不良记录列表
      ], 
      currentPage2: 1,
      pageSize2: 10,
      totalItems2: 0,
    }
  },
  mounted() {
    this.groupId = this.$store.state.groupId
    this.joinType = util.session.get('roleId')=='3'?'3':'2'
    if ('' == this.groupId || undefined == this.groupId) {
      this.groupId = util.session.get('groupId')
    }
    this.getData()
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    //获取数据
    getData() {
      var that = this
      myHttp
        .secBadRecordByEntIdAndJoinType({
          joinType: this.joinType,
          entId: this.groupId,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          name: this.name
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.list.list || []
            that.tableList = list
            that.totalItems = resp.data.data.list.total
          }
        })
    },

    tableRowClassName({ row, rowIndex }) {
      // if (rowIndex%2 === 0) {
      // return 'full-row';
      // } else if (rowIndex%2 === 1) {
      // return 'null-row';
      // }
      return 'full-row'
    },
    //跳转详情
    toHistory(row) {
      if(util.session.get('roleId')=='3'){
        this.$router.push({ path: '/badEntPerson/' + row.personId })
      }else{
        this.$router.push({ path: '/badPerson/' + row.personId })
      }
      
    },

    handleSizeChange1(val) {
      this.pageSize1 = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val
      // this.currentChangePage()
    },

    handleSizeChange2(val) {
      this.pageSize2 = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val
      // this.currentChangePage()
    },
  }
}
</script>
<style scoped>
* {
  box-sizing: border-box;
}
.box {
  width: 100%;
  position: relative;
  height: 100%;
  background: #fff;
}
.box-head {
  width: 100%;
  height: 40px;
  position: relative;
  display: flex;
  padding: 0 20px;
}
.box-table {
  width: 100%;
  height: calc(100% - 40px);
  position: relative;
  overflow: auto;
}
.el-table .box-head-title {
  font-size: 16px;
}

.flex-algin {
  display: flex;
  align-content: center;
  align-items: center;
}
.felx-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bg-color1 {
  background: #f5f5f5;
}
.bg-color2 {
  background: #0d2dff;
}
.bg-color3 {
  background: #ffbc01;
}
.bg-color4 {
  background: #36c635;
}
.bg-color5 {
  background: #886cff;
}
.color1 {
  color: #17b2fe;
}
.color2 {
  color: #886cff;
}
</style>
<style>
.tqm .el-table .table-head-cell,
.tqm .table-head-row {
  background: #fff;
  color: #4c9aff;
  font-size: 18px;
  text-align: center;
}
.tqm .el-table .full-row {
  background: #fbfbfb !important;
  color: #4c9aff;
  font-size: 18px;
  text-align: center;
}
.tqm .el-table .null-row {
  background: #fff !important;
  border: 0;
  height: 10px;
}
.tqm .el-table .el-table__empty-block {
  background: #fff;
  color: #4c9aff;
  font-size: 18px;
  border: 0;
}
.tqm .el-table td,
.tqm .el-table th.is-leaf {
  border: 0;
  border-bottom: 10px solid #fff;
}
.tqm .el-table--enable-row-hover .el-table__body tr:hover > td,
.el-table,
.tqm .el-table__expanded-cell {
  background-color: inherit;
}
.tqm .el-pagination span {
  color: #fff;
}
.head-search .el-input__inner{
  background: #fff;
}
</style>